module.exports = __webpack_public_path__ + "media/country_flags/nf-cbd5b21a.png";